module.exports = __webpack_public_path__ + "img/20190524164123498.b98a11aa.png";